import { privateAPI } from 'services/private';

const patchContactsDraft = (draft, contact) => {
  if (!Array.isArray(draft?.data)) {
    return false;
  }

  const items = draft.data;
  const existingIndex = items.findIndex(item => Number(item.id) === Number(contact.id));

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  }

  items.unshift({
    ...contact,
    is_unread: true,
  });

  return true;
};

export default function upsertClientContactListItem(dispatch, contact) {
  if (!contact?.id) {
    return false;
  }

  let patched = false;

  try {
    dispatch(
      privateAPI.util.updateQueryData('listContacts', undefined, draft => {
        if (patchContactsDraft(draft, contact)) {
          patched = true;
        }
      })
    );
  } catch {
    // Cache entry may not exist yet.
  }

  return patched;
}
